const PlusComponent = () => {
  return <>&#65291;</>;
};

export { PlusComponent as Plus };
